export default httpClient => ({
    logarSistema: async ({ email, password }) => {
        const response = await httpClient.post('/admin/login', {
            email,
            password
        })
        let errors = null
        if (!response.data) {
            errors = {
                status: response.request.status,
                statusText: response.request.statusText
            }
        }
        return {
            data: response.data,
            errors
        }
    },
    verificaToken: async (token) => {
        let headers = {
            "Authorization": "Bearer " + token
        }
        const response = await httpClient.get('/verifica-token', {
            headers
        })

        let errors = null

        if (!response.data) {
            errors = {
                status: response.request.status,
                statusText: response.request.statusText
            }
        }
        return {
            data: response.data,
            errors
        }
    },

        logout: async (token) => {
        let headers = {
            "Authorization": "Bearer " + token
        }
        const response = await httpClient.get('/logout', {
            headers
        })

        let errors = null

        if (!response.data) {
            errors = {
                status: response.request.status,
                statusText: response.request.statusText
            }
        }
        return {
            data: response.data,
            errors
        }
    },
})
